/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';

const Login = {
	$domLoginBtn: $('.js-profile-reg-btn'),
	isFetching: false,

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		this.$domLoginBtn.on('click', this.loginForm);
	},

	/**
	 * @description Show error messages
	 */
	showErrorMessages: function(message) {
		const $messagesContainer = $('.js-profile-auth-messages');
		$messagesContainer.html(`<div class="profile-auth__error">${message}</div>`);
	},

	/**
	 * @description Clear error messages
	 */
	clearErrorMessages: function() {
		const $messagesContainer = $('.js-profile-auth-messages');
		$messagesContainer.html('');
	},

	/**
	 * @description Handles user login
	 */
	loginForm: async function(event) {
		event.preventDefault();

		if (Login.isFetching) {
			return;
		}

		const $form = $(this).closest('form');
		const username = $form.find('input[name="login_username"]').val();
		const password = $form.find('input[name="login_password"]').val();
		const redirectTo = $form.find('input[name="redirect_to"]').val();
		const referrer = document.referrer;

		// Clear previous messages
		Login.clearErrorMessages();

		// Validate fields
		if (!username || !password) {
			Login.showErrorMessages('Molimo vas da unesete i email i lozinku.');
			return;
		}

		Login.isFetching = true;

		try {
			const response = await fetch('/wp-json/office-pulse-api/v1/auth/login', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					username: username,
					password: password,
					referrer: referrer
				}),
			});

			const result = await response.json();

			if (response.ok && result.success) {
				console.log(result);
				window.location.href = result.redirect || '/';
			} else {
				Login.showErrorMessages(result.error || 'Došlo je do greške. Pokušajte ponovo.');
			}
		} catch (error) {
			console.error('Login fetch error:', error);
			Login.showErrorMessages('Došlo je do greške. Pokušajte ponovo kasnije.');
		} finally {
			Login.isFetching = false;
		}
	},
};

export default Login;

